<div class="programmes" *ngIf="CanReview(); else notReviewer">
  <div *ngFor="let programme of programmes"
       class="programme_row"
       [class.selected]="programme === currentProgramme"
       [style.background-color]="this.getColorFor(programme)"
       (click)="gotoDetail(programme)">
    <span class="badge">{{programme.id}}</span>
    <span class="name">{{programme.name}}</span>
    <span class="description">{{programme.description}}</span>
    <span class="url">{{programme.url}}</span>
  </div>
  <!-- div *ngIf="CanAdminister()">
    <div *ngIf="adding; else addmore">
      <!-- programme-detail [inserting]="cancelInsert" (cancelled)="cancelInsert()"></programme-detail -x->
      <img src="/images/cancel.svg" (click)="cancelInsert()" class="addlink">
    </div>
    <ng-template #addmore>
      <img src="/images/plus.svg" (click)="addProgramme()" class="addlink">
    </ng-template>
  </div -->
</div>
<ng-template #notReviewer>Not a reviewer.</ng-template>
